/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { GeneratePromptResponseWithFileMutationRequest, GeneratePromptResponseWithFileMutationResponse, GeneratePromptResponseWithFile400, GeneratePromptResponseWithFile401, GeneratePromptResponseWithFile404, GeneratePromptResponseWithFile409, GeneratePromptResponseWithFile500 } from "../../types/GeneratePromptResponseWithFile.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";
import { buildFormData } from "../../.kubb/config.js";

function getGeneratePromptResponseWithFileUrl() {
  const res = { method: 'POST', url: `/api/prompt/file` as const }
  return res
}

/**
 * @description Generates a prompt response using multipart/form-data input, allowing file uploads. This endpoint is useful when the prompt generation requires additional file data. Returns immediately with task ID - poll /{promptRewardID}/status for completion.
 * @summary Generate Prompt Response with File
 * {@link /api/prompt/file}
 */
export async function generatePromptResponseWithFile(data?: GeneratePromptResponseWithFileMutationRequest, config: Partial<RequestConfig<GeneratePromptResponseWithFileMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const formData = buildFormData(requestData)
  const res = await request<GeneratePromptResponseWithFileMutationResponse, ResponseErrorConfig<GeneratePromptResponseWithFile400 | GeneratePromptResponseWithFile401 | GeneratePromptResponseWithFile404 | GeneratePromptResponseWithFile409 | GeneratePromptResponseWithFile500>, GeneratePromptResponseWithFileMutationRequest>({ method : "POST", url : getGeneratePromptResponseWithFileUrl().url.toString(), data : formData as FormData, ... requestConfig })
  return res.data
}